import React, { lazy } from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
export function Contact() {
  return <section id="iletisim" className="py-16 bg-gray-50" data-id="element-28">
      <div className="container mx-auto px-4" data-id="element-29">
        <div className="text-center mb-12" data-id="element-30">
          <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-31">İletişim</h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-32">
            Dizel motor arızaları ve bakımı ile ilgili tüm sorularınız için bize
            ulaşabilirsiniz.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-33">
          <div className="lg:col-span-1 bg-blue-900 text-white rounded-lg p-8" data-id="element-34">
            <h3 className="text-xl font-bold mb-6" data-id="element-35">İletişim Bilgileri</h3>
            <div className="space-y-6" data-id="element-36">
              <div className="flex items-start" data-id="element-37">
                <PhoneIcon className="w-6 h-6 text-green-500 mr-4 mt-1" data-id="element-38" />
                <div data-id="element-39">
                  <h4 className="font-bold" data-id="element-40">Telefon</h4>
                  <p className="mt-1" data-id="element-41">+90 264 278 08 92</p>
                  <p data-id="element-42">+90 532 284 75 63</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-43">
                <MailIcon className="w-6 h-6 text-green-500 mr-4 mt-1" data-id="element-44" />
                <div data-id="element-45">
                  <h4 className="font-bold" data-id="element-46">E-posta</h4>
                  <p className="mt-1" data-id="element-47">tahausta@guvendizel.com</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-48">
                <MapPinIcon className="w-6 h-6 text-green-500 mr-4 mt-1" data-id="element-49" />
                <div data-id="element-50">
                  <h4 className="font-bold" data-id="element-51">Adres</h4>
                  <p className="mt-1" data-id="element-52">Tuzla, 1270. Sk. No:35</p>
                  <p data-id="element-53">54100 Adapazarı/Sakarya, Türkiye</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-54">
                <ClockIcon className="w-6 h-6 text-green-500 mr-4 mt-1" data-id="element-55" />
                <div data-id="element-56">
                  <h4 className="font-bold" data-id="element-57">Çalışma Saatleri</h4>
                  <p className="mt-1" data-id="element-58">Pazartesi - Cumartesi: 08:00 - 18:00</p>
                  <p data-id="element-59">Pazar: Kapalı</p>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:col-span-2 bg-white rounded-lg shadow-lg overflow-hidden h-full flex" data-id="element-60">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1827.0750668401718!2d30.418964272731824!3d40.7957627225981!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x409df64f05555555%3A0x8eb54845c65b5b61!2sGuven%20Dizel%20Pompa!5e0!3m2!1sen!2spt!4v1759059949799!5m2!1sen!2spt" width="100%" height="100%" style={{
            border: 0,
            display: 'block',
            flexGrow: 1
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-61"></iframe>
          </div>
        </div>
      </div>
    </section>;
}